import Vue from 'vue';
import ActMcityDialog from './ActMcityDialog.vue';

let instance;

const defaultOptions = {
  value: true,
  overlay: true,
  lockOnScroll: true,
  closeOnClickOverlay: true,
  callback: (action,info) => {
    instance[action === 'confirm' ? 'resolve' : 'reject']({action,info});
  },
  title: "<p>提示1</p><p>提示2</p>",
  button: "确认"
};

let currentDefaultOptions = {
  ...defaultOptions
};

const initInstance = () => {
  const DialogConstructor = Vue.extend(ActMcityDialog);
  instance = new DialogConstructor({
    el: document.createElement('div')
  });

  instance.$on('input', value => {
    instance.value = value;
  });

  document.body.appendChild(instance.$el);
};

const Dialog = options => {
  return new Promise((resolve, reject) => {
    if (!instance) {
      initInstance();
    }

    Object.assign(instance, {
      resolve,
      reject,
      ...options
    });
  });
};

//
Dialog.show = options => {
  if(typeof options === 'object'){
    return Dialog({
      ...currentDefaultOptions,
      ...options
    });
  }else if(typeof options === 'string'){
   return  Dialog({
      ...currentDefaultOptions,
     title: `<div style="text-align: center;font-size:.36rem">${options}<div>`
    });
  }
}



// //简易显示文本
// Dialog.show_simple = (tip_text) => Dialog({
//   ...currentDefaultOptions,
//   title: null,
//   content: `<div style="text-align: center;font-size:.36rem">${tip_text}<div>`
// });


Dialog.close = () => {
  instance.value = false;
};

Dialog.setDefaultOptions = (options = {}) => {
  currentDefaultOptions = {
    ...currentDefaultOptions,
    ...options
  };
};

Dialog.resetDefaultOptions = () => {
  currentDefaultOptions = {
    ...defaultOptions
  };
};

Vue.prototype.$act_mcity_dialog = Dialog;
window.$act_mcity_dialog = Dialog;

export default Dialog;
export {
  ActMcityDialog as Dialog
};

import preload from '../../../tools/preload'
preload([
  "https://vipcdn.mgtv.com/lego/20211223/lego/2b1038bc63d811ecbe25005056921140.png"
]);
